import script from "./vechart.vue?vue&type=script&setup=true&lang=js"
export * from "./vechart.vue?vue&type=script&setup=true&lang=js"

import "./vechart.vue?vue&type=style&index=0&id=3cb7bbd5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3cb7bbd5"]])

export default __exports__